module.exports = __webpack_public_path__ + "img/logo.3ab91046.png";